import usePostboxes from './usePostboxes';

export default usePostboxes;
